import script from "./ServicesView.vue?vue&type=script&setup=true&lang=js"
export * from "./ServicesView.vue?vue&type=script&setup=true&lang=js"

import "./ServicesView.vue?vue&type=style&index=0&id=6aab82d0&lang=css"

const __exports__ = script;

export default __exports__